import styled from '@emotion/styled'
import { colors, typography } from '@resiliatech/birdsong'
import { Slider } from '@mui/material'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`

export const SlidersContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px 40px;
  background-color: rgba(0, 63, 126, 0.04);
  gap: 24px;
`

export const PriorityContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const PriorityTitle = styled.div`
  ${typography.baseline.semiBoldSans};
  color: #000;
`

export const SliderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 12px;
`

export const StyledSlider = styled(Slider)`
  height: 4px;
  padding: 15px 0;

  & .MuiSlider-thumb {
    background-color: ${colors.feedback.infoDark};
    width: 16px;
    height: 16px;

    &[style*='left: 0%'] {
      background-color: ${colors.interactive.disabledLight};
    }

    &:before {
      box-shadow: none;
    }
  }

  & .MuiSlider-markLabel {
    color: #000000;
    opacity: 87%;
    ${typography.baseline.semiBoldSans};

    &[data-index='0'] {
      ${typography.down1.regularSansItalic};
      transform: none;
      left: 0 !important;
      opacity: 87%;
    }
  }

  & .MuiSlider-mark {
    display: none;
  }

  & .MuiSlider-rail {
    opacity: 1;
    background-color: #e5e5e5;
  }

  & .MuiSlider-track {
    background-color: #003f7e;
    border: none;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: auto;
`
